/* global $ showAlert */
import { Controller } from 'stimulus';

class SubmitController extends Controller {
  // eslint-disable-next-line class-methods-use-this
  handleClick(event) {
    event.preventDefault();
    const target = event.currentTarget;

    if ($(target).attr('disabled')) {
      return;
    }

    $(target).attr('disabled', true);
    const { method, url, successRedirectUrl } = target.dataset;

    fetch(url, {
      method,
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'),
        Accept: 'text/javascript',
      },
    }).then(async (response) => {
      if (response.ok) {
        window.location.href = successRedirectUrl;
      } else {
        const body = await response.json();
        $(target).attr('disabled', false);
        showAlert({ message: body.errors });
      }
    });
  }
}

export default SubmitController;
